import { Card } from "antd";

export const SectionCard = ({
  icon,
  title,
  extra,
  children,
  className = "",
  bodyStyle,
  padding = false,
}) => (
  <Card
    className={`spor-section-card ${className}`}
    title={
      <div className="spor-section-card-head">
        {icon && <span className="spor-section-card-icon">{icon}</span>}
        <span>{title}</span>
      </div>
    }
    extra={extra}
    bodyStyle={bodyStyle ?? (padding ? { padding: "20px 22px" } : { padding: 0 })}
  >
    {children}
  </Card>
);
